import React from "react";
import "./Banner.css";

export default function Banner({ title, image }) {
  return (
    <section
      className="aheader-wrapper"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="aheader-overlay">
        <h1 className="aheader-title">{title}</h1>
        <p className="aheader-breadcrumb">
          Home <span className="aheader-separator">›</span> {title}
        </p>
      </div>
    </section>
  );
}
